import { render, staticRenderFns } from "./wholesale.vue?vue&type=template&id=00ac21c0&scoped=true&"
import script from "./wholesale.vue?vue&type=script&lang=js&"
export * from "./wholesale.vue?vue&type=script&lang=js&"
import style0 from "./wholesale.vue?vue&type=style&index=0&id=00ac21c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ac21c0",
  null
  
)

export default component.exports